import React from "react"

const COLORS = {
  primary: "#F7454B",
  default: "#FFFFFF"
}

type Props = {
  color?: "primary" | "default";
  style?: any
}

export const FilterIcon = ({ color, style }: Props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <g clipPath="url(#clip0_4468_5900)">
      <path d="M15.4664 1.36939C15.4709 1.30112 15.4613 1.23265 15.4383 1.16822C15.4153 1.10379 15.3793 1.04476 15.3326 0.994786C15.2858 0.944807 15.2293 0.904937 15.1666 0.877638C15.1039 0.850338 15.0362 0.836187 14.9678 0.83606H0.999779C0.931329 0.83609 0.863614 0.850175 0.800829 0.877441C0.738043 0.904708 0.681526 0.944576 0.634776 0.994575C0.588027 1.04457 0.552042 1.10364 0.52905 1.16811C0.506058 1.23259 0.496549 1.30109 0.501112 1.36939C0.618366 3.00206 1.26635 4.55159 2.34625 5.78171C3.42615 7.01182 4.87871 7.85502 6.48245 8.18273V14.7661C6.48248 14.8611 6.50959 14.9541 6.56058 15.0343C6.61158 15.1144 6.68436 15.1784 6.7704 15.2187C6.85644 15.259 6.95218 15.2739 7.0464 15.2618C7.14063 15.2496 7.22945 15.2109 7.30245 15.1501L9.30245 13.4834C9.35883 13.4366 9.40419 13.3779 9.4353 13.3115C9.46641 13.2451 9.48251 13.1727 9.48245 13.0994V8.18273C11.0867 7.85564 12.5399 7.01269 13.6204 5.78251C14.7008 4.55233 15.3492 3.00247 15.4664 1.36939Z" stroke={COLORS[color]} strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_4468_5900">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/ChatsList/FilterIcon.tsx